import type { FaireProductEntity } from "../../entity_types/product";

export const p_ss2fxmbx6m: FaireProductEntity = {
  token: "p_ss2fxmbx6m",
  type: "product",
  name: "Lobster Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6d3a5ebb55b769e0f38f27d4d27d8406e5741cf16c4cf6911772338bcd827ff3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f918cef9b365e4d7ff5bc9e31edfff9473a9ccae91bb7e0dfd43df4ce402ecec.jpeg",
    "https://cdn.faire.com/fastly/55d5bcb7e13f40de0fa968907e6dc340b699c8bf187fac38bab272f55ef7c182.jpeg",
    "https://cdn.faire.com/fastly/9f2d2c4262fce4783f3e3a9b56a7ec0d193d4b8a18bb252cccf4089b8d92109e.jpeg",
    "https://cdn.faire.com/fastly/a14c88521ab61193fb32f43e15d1bc24ea77da02165d98a087e21164c002c030.png",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:33.284Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
